/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RibbonIcon = ({ width = 24, height = 24, hidden = false, title = 'Ribbon' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m16.34521,16.37939l-1.9281-4.45544c1.13184-1.13171,1.83289-2.69434,1.83289-4.4176,0-3.44629-2.80371-6.25-6.25-6.25S3.75,4.06006,3.75,7.50635c0,1.72327.70105,3.28589,1.83289,4.4176l-1.9281,4.45544c-.10303.23877-.0752.51367.07324.72656.14844.21338.39111.32715.65674.32031l1.85791-.10303,1.19727,1.42529c.14355.1709.35449.26758.57422.26758.03809,0,.07666-.00293.11523-.00879.25928-.04053.47852-.21338.57861-.45605l1.29199-3.14209,1.29199,3.14209c.1001.24268.31934.41553.57861.45605.03857.00586.07715.00879.11523.00879.21973,0,.43066-.09668.57422-.26758l1.19727-1.42529,1.85791.10303c.2666.00732.5083-.10693.65674-.32031.14844-.21289.17627-.48779.07324-.72656ZM5.25,7.50635c0-2.61914,2.13086-4.75,4.75-4.75s4.75,2.13086,4.75,4.75-2.13086,4.75-4.75,4.75-4.75-2.13086-4.75-4.75Zm2.5415,9.32861l-.6416-.76367c-.15186-.18018-.37988-.27734-.61572-.2666l-1.02051.05664,1.29449-2.99121c.68665.41016,1.4566.69067,2.27979.81201l-1.29645,3.15283Zm5.67432-1.03027c-.24316-.01172-.46338.08643-.61572.2666l-.6416.76367-1.29645-3.15283c.82318-.12134,1.59314-.40186,2.27979-.81201l1.29449,2.99121-1.02051-.05664Z"
      fill="currentColor"
    />
  </svg>`;
};
